// Valeurs alignées sur l'enum API `sort` partagé par getSpecieList et getObservationSpecieList
// (renommé au sync : popularity→observations, creation_date→date, label→alpha, taxon_label→taxon).
// Les clés i18n gardent leur ancien nom (le libellé affiché est inchangé).
export const SPECIES_SORT_VALUES = ["observations_desc", "date_desc", "alpha_asc", "alpha_desc", "taxon_asc"] as const;

export type SpeciesSort = (typeof SPECIES_SORT_VALUES)[number];

export interface SortOption<T extends string> {
  label: string;
  value: T;
}
